import { render, staticRenderFns } from "./ModalMantenedor.vue?vue&type=template&id=15d7f062&"
import script from "./ModalMantenedor.vue?vue&type=script&lang=ts&"
export * from "./ModalMantenedor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports